import { container } from '@graphistry/falcor-react-redux';
import { onSearch } from '@graphistry/viz/src/actions/search'

import { FormControl, Card } from 'react-bootstrap';

function InvestigationSearch({ onSearchTermChange, searchTerm }) {
    console.log(searchTerm);
    return (
        <div style={{
            width: 300,
            position: "relative",
            left: 0,
            top: 0,
            padding: 10
        }}>
            <Card>
                <Card.Header>Search Graph</Card.Header>
                <Card.Body>
                    <FormControl
                        type="text"
                        placeholder="Search"
                        className="mr-sm-2"
                        value={searchTerm}
                        onChange={({ target: { value } }) => onSearchTermChange(value)}
                    />
                </Card.Body>
            </Card>
        </div>
    );
}

InvestigationSearch = container({ //
    renderLoading: false,
    fragment: () => `{
        searchTerm
    }`,
    mapFragment(data, props, $falcor) {
        return { ...data, ...props, $falcor };
    },
    dispatchers: {
        onSearchTermChange: onSearch
    }
})(InvestigationSearch);

export { InvestigationSearch }
